import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SBPayments } from '@sb-software/sb-payments-editec';
import { paymentProviders } from 'paymentActions.js';
import { translation } from 'helpers/utilsHelper.js';
import { providerSettingsSelector } from 'paymentsSelector.js';
import Loader from 'Loader.js';
import S from 'StyledAccountDeposit.js';
import {loadCustomerData} from 'customerActions.js';

const { Withdraw, useSession } = SBPayments;

const AccountWithdraw = ({ dispatch, brandData, providers, isPending, loadCustomerData }) => {
  const { payouts } = providers ?? {};
  const { brandId, mainCurrency, countryCode, mobilePrefix } = brandData ?? {};
  const mobileNumberLength = app.config.mobileNumberLength;

  const retrieveProviders = async () => {
    try {
      if (mainCurrency) {
        await dispatch(paymentProviders(mainCurrency));
      } else {
        await dispatch(paymentProviders());
      }
    } catch (error) {
      console.log('paymentProviders error:' + error);
    }
  };

  const getLang = () => {
    return `lang_${app.config.lang.toLowerCase()}_${countryCode.toLowerCase()}_${brandId}_1`;
  };

  const refreshCustomerBalance = () => {
    loadCustomerData();
  }

  const paymentsProps = {
    session: useSession(),
    lang: getLang(),
    currencyCode: mainCurrency,
    countryCode: countryCode,
    brandId,
    mobilePrefix,
    useCaptcha: app.config.useTurnstileCaptcha.useTurnstileCaptchaForIWG,
    refreshCustomerBalance: refreshCustomerBalance,
    mobileNumberLength: mobileNumberLength,
  };

  useEffect(() => {
    retrieveProviders();
  }, []);

  if (isPending) return <Loader />;

  return payouts?.length ? <Withdraw {...paymentsProps} /> : <S.NoActiveProviders>{translation('payments_noActiveProviders')}</S.NoActiveProviders>;
};

const mapStateToProps = (state, props) => {
  const {
    Auth: { brandData },
    AccountDeposit: { isPending },
  } = state;
  const providers = providerSettingsSelector(state, props);

  return {
    brandData,
    providers,
    isPending,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      loadCustomerData: bindActionCreators(loadCustomerData, dispatch),
      dispatch
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountWithdraw);
